import { Link } from "react-router-dom";

export const DatenschutzPage = () => {
  return (
    <main className="lpv2-legal-wrap">
      <section className="lpv2-legal-card">
        <h1>Datenschutzerklärung</h1>
        <p className="lpv2-legal-lead">
          Diese Hinweise informieren über die Verarbeitung personenbezogener Daten auf der Website und im
          Demoanfrageprozess der Beschluss-APP.
        </p>

        <h2>1. Verantwortlicher</h2>
        <p>
          Emig Immobilien
          <br />
          An der Fahrt 13 | 55124 Mainz
          <br />
          E-Mail: <a href="mailto:mail@derumlaufbeschluss.de">mail@derumlaufbeschluss.de</a>
        </p>

        <h2>2. Verarbeitete Daten bei Website-Nutzung</h2>
        <p>
          Beim Aufruf der Website werden technisch erforderliche Zugriffsdaten verarbeitet (z. B. IP-Adresse, Datum und
          Uhrzeit, angefragte URL, Browser-Informationen), um die Website sicher und stabil bereitzustellen.
        </p>

        <h2>3. Demoformular</h2>
        <p>
          Bei Nutzung des Demoformulars verarbeiten wir die von Ihnen eingegebenen Daten (Name, Firma/Verwaltung,
          E-Mail, Telefonnummer, optionale Angaben und Nachricht), um Ihre Anfrage zu bearbeiten und mit Ihnen Kontakt
          aufzunehmen.
        </p>

        <h2>4. Captcha-Schutz (Cloudflare Turnstile)</h2>
        <p>
          Zum Schutz vor Spam und Missbrauch ist das Formular mit Cloudflare Turnstile abgesichert. Dabei können
          personenbezogene Daten (u. a. IP-Adresse und technische Nutzungsdaten) an Cloudflare übermittelt werden.
          Rechtsgrundlage ist unser berechtigtes Interesse an der Absicherung des Formulars.
        </p>

        <h2>5. E-Mail-Kommunikation</h2>
        <p>
          Demoanfragen werden an <a href="mailto:mail@derumlaufbeschluss.de">mail@derumlaufbeschluss.de</a>{" "}
          übermittelt und zur Bearbeitung der Anfrage genutzt.
        </p>

        <h2>6. Speicherdauer</h2>
        <p>
          Personenbezogene Daten werden nur so lange gespeichert, wie dies für die Bearbeitung der Anfrage oder zur
          Erfüllung gesetzlicher Aufbewahrungspflichten erforderlich ist.
        </p>

        <h2>7. Ihre Rechte</h2>
        <p>
          Sie haben das Recht auf Auskunft, Berichtigung, Löschung, Einschränkung der Verarbeitung, Datenübertragbarkeit
          sowie Widerspruch gegen die Verarbeitung. Zudem besteht ein Beschwerderecht bei einer
          Datenschutzaufsichtsbehörde.
        </p>

        <h2>8. Stand</h2>
        <p>Stand: April 2026</p>

        <div className="lpv2-legal-back">
          <Link to="/">Zurück zur Startseite</Link>
        </div>
      </section>
    </main>
  );
};
